export default __webpack_public_path__ + "static/media/pink_pawn.74919ff7.png";